import {
  stepAgentConfig,
  stepInteractContrastUI,
  stepSelectLinuxMacOSNormalize
} from './common'
import { OPERATING_SYSTEM } from '../common/constants'
import { ImageIcon } from '../common/image-icon'
import { logo_manual } from '../images'
import React from 'react'

const stepConfigureMiddleware = (name, code) => ({
  number: 4,
  defaultIsOpen: true,
  titleMsg: 'title_configureMiddleware',
  Content: { message: 'detail_configureMiddleware', values: { name, code } }
})

const SteptNoMiddlewareConfigNormalized = (name) => ({
  defaultIsOpen: true,
  titleMsg: 'title_configureMiddleware',
  Content: { message: 'detail_noMiddlwareConfigNormalized', values: { name } }
})

const commonFinalSteps = [stepAgentConfig, stepInteractContrastUI]

const installMethods = {
  titleMsg: 'title_applicationDeploymentMethod',
  defaultIsOpen: true,
  Content: {
    options: [
      {
        value: 'manually',
        Content: 'Install manually',
        icon: <ImageIcon src={logo_manual} alt="manually" />
      }
    ]
  }
}

const stepSelectManuallyNormalize = {
  ...installMethods,
  Content: {
    options: installMethods.Content.options.filter(
      (it) => (it.value = 'manually')
    )
  }
}

const manuallySteps = [
  {
    titleMsg: 'title_installRubyAgent',
    defaultIsOpen: true,
    Content: { message: 'detail_installRubyAgent' }
  },
  {
    titleMsg: 'title_selectMiddleware',
    defaultIsOpen: true,
    Content: {
      options: [
        { value: 'rails', Content: 'Rails' },
        { value: 'sinatra', Content: 'Sinatra' },
        { value: 'grape', Content: 'Grape' }
      ]
    },
    branchKey: 'ruby-middleware',
    branches: {
      rails: [SteptNoMiddlewareConfigNormalized('Rails'), ...commonFinalSteps],
      sinatra: [
        stepConfigureMiddleware(
          'Sinatra',
          `require 'sinatra'
require 'contrast-agent'

class App < Sinatra::Base
  use Contrast::Agent::Middleware, true
end`
        ),
        ...commonFinalSteps
      ],
      grape: [
        stepConfigureMiddleware(
          'Grape',
          `require 'grape'
require 'contrast-agent'

class App < Grape::API
  use Contrast::Agent::Middleware, true
end`
        ),
        ...commonFinalSteps
      ]
    }
  }
]

export const rubyWizardStepsNormalizeAgentDownload = [
  { ...stepSelectLinuxMacOSNormalize, branchKey: OPERATING_SYSTEM.KEY },
  { ...stepSelectManuallyNormalize, branchKey: 'ruby-install' },
  ...manuallySteps
]
